import { Director as PrismaDirector } from '@commenda/prisma';

const formatDirectorName = (director: PrismaDirector) => {
  const {
    directorFirstName: firstName,
    directorMiddleName: middleName,
    directorLastName: lastName,
  } = director;

  return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

const formatPersonName = (parts: {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}): string =>
  [parts.firstName, parts.middleName, parts.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

export { formatDirectorName, formatPersonName };
